
    /**
     * @description
     *  Modelo de un usuario de aplicación.
     *
     * @see gigot-backend/Models/Users/ApplicationUser.cs
     */

export class ApplicationUser {

    // TODO: Completar propiedades, método 'empty' y método 'from'.

    /**
     * @description
     *	Construye un usuario con una semántica vacía. Nótese que no es lo
     *  mismo que construir un usuario con valores por defecto. Las reglas
     *  generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un usuario de aplicación vacío.
     */
    public static empty(): ApplicationUser {
        const applicationUser: ApplicationUser = new ApplicationUser();
        return applicationUser;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicApplicationUser
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
	public static from(anemicApplicationUser: ApplicationUser): ApplicationUser {
		if (!anemicApplicationUser) return undefined;
        const applicationUser: ApplicationUser = ApplicationUser.empty();
		return applicationUser;
	}
}
